jQuery(document).ready(function () {
  $(".burger--menu").click(function () {
    var $this = $(this);
    var popUpMenu = $this.closest(".header--bottom").find(".drop-down--menu");

    if ($this.hasClass("active")) {
      $this.removeClass("active");
      popUpMenu.fadeOut(function () {
        $("header.sm-main--header").removeClass("active");
        $("html").removeClass("active--menu");
      });
    } else {
      $this.addClass("active");
      $("header.sm-main--header").addClass("active");
      $("html").addClass("active--menu");
      popUpMenu.fadeIn();
    }
  });

  if ($(".js-img-compare").length) {
    $(".js-img-compare").imagesCompare();
  }

  /* Header on scroll */

  $(window).scroll(function () {
    if ($(document).scrollTop() > 40) {
      $("header.sm-main--header").addClass("sticky");
    } else {
      $("header.sm-main--header").removeClass("sticky");
    }
  });

  // Mega Menu

  $(".main--header .hamburger--icon").on("click", function () {
    var mainHeader = $(".main--header");
    s;

    if (mainHeader.hasClass("active")) {
      $(".main--header").removeClass("active");
    } else {
      $(".main--header").addClass("active");
      gsap.from(".parent--li li", {
        x: "-35%",
        autoAlpha: 0,
        ease: Power0.easeNone,
        stagger: 0.1,
      });
    }
  });

  // Search

  $(".main--header .header--search-icon").on("click", function () {
    var mainHeader = $(".main--header");

    if (mainHeader.hasClass("active--search")) {
      $(".main--header").removeClass("active--search");
    } else {
      $(".main--header").addClass("active--search");
    }
  });

  // Counter Block

  if ($(".counter--block").length) {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    function observerCallback(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          $(entry.target)
            .find("span.integer__")
            .each(function () {
              const $this = $(this);
              $this.prop("Counter", 0).animate(
                {
                  Counter: $this.text(),
                },
                {
                  duration: 4000,
                  easing: "swing",
                  step: function (now) {
                    now = Number(Math.ceil(now)).toLocaleString("en");
                    $this.text(now);
                  },
                }
              );

              observer.unobserve(entry.target);
            });
        }
      });
    }

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );

    $(".counter--block").each(function () {
      observer.observe(this);
    });
  }

  function stickyCustomSidebar() {
    // Check if screen width is above 980px
    if ($(window).width() > 980) {
      // Clear previous ScrollMagic controller
      if (window.controller) {
        window.controller.destroy(true);
      }

      window.controller = new ScrollMagic.Controller();
      var tl = new TimelineMax();
      var contents = new TimelineMax();

      $(".custom-sticky__sidebar").each(function () {
        var $this = $(this);
        var height =
          parseInt(
            $(".block--with-sidebar .custom-sticky__body--inner").innerHeight()
          ) -
          $(
            ".block--with-sidebar .custom-sticky__sidebar--inner"
          ).innerHeight();

        new ScrollMagic.Scene({
          triggerElement: ".block--with-sidebar .custom-sticky__body--inner",
          triggerHook: 0.1,
          duration: height,
        })
          .setPin(".custom-sticky__sidebar--inner", {
            pushFollowers: false,
          })
          // .addIndicators()
          .addTo(window.controller);
      });
    } else {
      // Destroy the controller and unpin elements for screens below 980px
      if (window.controller) {
        window.controller.destroy(true);
        $(".custom-sticky__sidebar--inner").css("position", "static");
      }
    }
  }

  if ($(".custom-sticky__sidebar").length) {
    $(window).on("load", function () {
      stickyCustomSidebar();
    });
  }

  $(window).resize(function () {
    stickyCustomSidebar();
  });

  // Add to Cart Ajax

  // $('.product-form').on('submit', function (event) {

  //     event.preventDefault();
  //     console.clear();
  //     var $this = $(this);
  //     var form = this;
  //     var formData = new FormData(form);
  //     var currentItemToAdd = $this.find('.to-add-cart-product-id').val();
  //     var productBlockContent = $this.closest('.product--block__content');

  //     var successMessage = productBlockContent.find('.succress--cart-response');
  //     var errorMessage = productBlockContent.find('.error--cart-response');

  //     successMessage.removeClass('active');
  //     errorMessage.removeClass('active');

  //     if (productBlockContent.find('.pbb--swatch').length) {
  //         if (productBlockContent.find('.swatch--' + currentItemToAdd).attr('data-cartalready') == '0') {
  //             submitData();
  //         }
  //         else {
  //             successMessage.removeClass('active');
  //             errorMessage.addClass('active');
  //         }
  //     }
  //     else {

  //         if ($this.attr('data-itemquantity') === '0') {
  //             submitData();

  //         }
  //         else {
  //             successMessage.removeClass('active');
  //             errorMessage.addClass('active');
  //         }

  //     }

  //     function submitData() {

  //         $.ajax({
  //             url: '/cart/add.js',
  //             method: 'POST',
  //             data: formData,
  //             processData: false,
  //             contentType: false,
  //             headers: {
  //                 'X-Requested-With': 'XMLHttpRequest'
  //             },
  //             beforeSend: function () {
  //                 $this.find('.btn').text('Loading...');

  //             },
  //             success: function (data) {

  //                 var getCurrentCartCount = $('.main--header .cart--item-count').attr('data-count');
  //                 var newCartValue = parseInt(getCurrentCartCount) + 1;

  //                 setTimeout(function () {

  //                     $this.find('.btn').text('ADD TO CART');
  //                     errorMessage.removeClass('active');
  //                     successMessage.addClass('active');

  //                     if (productBlockContent.find('.swatch--' + currentItemToAdd).length) {

  //                         var currentSelected = productBlockContent.find('.swatch--' + currentItemToAdd).attr('data-cartalready');
  //                         var updateSelectedCart = parseInt(currentSelected) + 1;
  //                         productBlockContent.find('.swatch--' + currentItemToAdd).attr('data-cartalready', updateSelectedCart);
  //                     }
  //                     else {

  //                         var currentSelected = $this.attr('data-itemquantity');
  //                         var updateSelectedCart = parseInt(currentSelected) + 1;
  //                         $this.attr('data-itemquantity', updateSelectedCart);

  //                     }

  //                     $('.main--header .cart--item-count span').text(newCartValue);

  //                 }, 500);

  //             },
  //             error: function (error) {
  //                 console.error('Error adding item to cart:', error);
  //             }
  //         });
  //     }

  // });

  if ($(".sm-accordion--main").length) {
    $(".sm-accordion--main").each(function () {
      var $this = $(this);
      var itemBlock = $this.find(".accordion--item");
      var titleToggle = $this.find(
        ".accordion--item .accordion--title__wrapper"
      );

      $this
        .find(".accordion--item")
        .first()
        .addClass("open")
        .find(".accordion--content")
        .show();

      if ($this.closest(".sm-accordion").hasClass("sm-accordion--type__2")) {
        titleToggle.on("mouseenter", function () {
          var $this__ = $(this);
          var content = $this__.next();
          $this.find(".accordion--content").slideUp();
          itemBlock.removeClass("open");

          if (content.is(":visible")) {
            content.slideUp();
          } else {
            content.slideDown();
            $this__.parent().addClass("open");
          }
        });
      } else {
        titleToggle.on("click", function () {
          var $this__ = $(this);
          var content = $this__.next();
          $this.find(".accordion--content").slideUp();
          itemBlock.removeClass("open");

          if (content.is(":visible")) {
            content.slideUp();
          } else {
            content.slideDown();
            $this__.parent().addClass("open");
          }
        });
      }
    });
  }

  $(".sm-values--wrapper").on("click", ".sm-values__inner", function (event) {
    $(".sm-values__inner").removeClass("active");
    $(this).addClass("active");
  });

  if ($(".sm-values").length) {
    $(".sm-values .col-md-4:first-child .sm-values__inner").addClass("active");
  }
  $(window).scroll(function () {
    if ($(document).scrollTop() > 80) {
      $("#home header.sm-main--header ").addClass("sticky");
    } else {
      $("#home header.sm-main--header").removeClass("sticky");
    }
  });
  $(".slider--image-each").slick({
    dots: false,
    arrows: false,
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  if ($(".sm-values--each__inner").length) {
    $(".sm-values--each__inner .sm-values--content:first").addClass("active");
  }

  testimonialSlider();

  function testimonialSlider() {
    var testimonialSlider = $(".sm-testimonials__slider").slick({
      dots: true,
      arrows: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      appendDots: $(
        ".testimonials--pagination .testimonials--pagination__dots"
      ),
      customPaging: function (slider, i) {
        return (
          '<button type="button" class="slick-dot">' + (i + 1) + "</button>"
        );
      },
    });

    const slideCount = testimonialSlider.slick("getSlick").slideCount;

    testimonialSlider.on("afterChange", function (event, slick, currentSlide) {
      const currentTestimonialItem = currentSlide + 1;
      if (currentTestimonialItem > 1) {
        $(".testimonials--pagination__arrow.tpa--left").addClass("active");
      } else {
        $(".testimonials--pagination__arrow.tpa--left").removeClass("active");
      }

      if (currentTestimonialItem == slideCount) {
        $(".testimonials--pagination__arrow.tpa--right").removeClass("active");
      } else {
        $(".testimonials--pagination__arrow.tpa--right").addClass("active");
      }
    });

    $(".testimonials--pagination .testimonials--pagination__arrow").on(
      "click",
      function () {
        var $this = $(this);

        if ($this.hasClass("tpa--left")) {
          testimonialSlider.slick("slickPrev");
        } else {
          testimonialSlider.slick("slickNext");
        }
      }
    );
  }

  sliderBlocks__();
  function sliderBlocks__() {
    var sliderBlock;

    if (
      $(
        ".slider--block .sm-product--block__inner, .sm-product--filter.sm-filter-with-options .sm-product--block__inner"
      ).length
    ) {
      $(
        ".slider--block .sm-product--block__inner, .sm-product--filter.sm-filter-with-options .sm-product--block__inner"
      ).each(function () {
        var $this_slide = $(this);
        var slideItemToScroll = $(this)
          .closest(".section-body--content")
          .hasClass("active-all")
          ? 3
          : 1;
        var currentCategory = $(this)
          .closest(".section-body--content")
          .find(".sm-product--filter__options ul li")
          .first()
          .addClass("active")
          .find("a")
          .attr("data-category");

        $(this)
          .closest(".section-body--content")
          .find(
            ".sm-product--block__main .sm-product--block__inner.collection-" +
              currentCategory
          )
          .addClass("active");

        sliderBlock = $(this).slick({
          dots: true,
          arrows: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          adaptiveHeight: true,
          infinite: true,
          appendDots: $this_slide
            .closest(".sbc__inner")
            .find(".custom--navigator .custom--navigator__dots"),
          customPaging: function (slider, i) {
            return (
              '<button type="button" class="slick-dot">' + (i + 1) + "</button>"
            );
          },
          responsive: [
            {
              breakpoint: 1024, 
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              },
            }, 
            {
              breakpoint: 599,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              },
            },
          ],
        });
      });
    }

    $(
      ".sm-product--filter__options-with-arrow .sm-product--filter__pagination .sm-product--filter__pagination--arrow"
    ).on("click", function () {
      var $this = $(this);

      if ($this.hasClass("sm-product--filter__pagination--prev")) {
        $this
          .closest(".sbc__inner")
          .find(".sm-product--block__inner")
          .slick("slickPrev");
      } else {
        $this
          .closest(".sbc__inner")
          .find(".sm-product--block__inner")
          .slick("slickNext");
      }
    });

    $(".sm-product--filter__options ul li a").on("click", function (event) {
      event.preventDefault();

      var $this = $(this);
      var category = $this.attr("data-category");
      var section_id = $this.attr("data-section-id");

      // Update active class
      $this.parent().addClass("active").siblings().removeClass("active");
      console.log("cat: " + category);
      // Select all product blocks
      $this
        .closest(".sbc__inner")
        .find(".sm-product--block__main .sm-product--block__inner")
        .removeClass("active");
      $this
        .closest(".sbc__inner")
        .find(
          ".sm-product--block__main .sm-product--block__inner.collection-" +
            category
        )
        .addClass("active");
        


      var $slider = $this
      .closest(".sbc__inner")
      .find(
        ".sm-product--block__main .sm-product--block__inner.collection-" + category
      );
      
            if ($slider.hasClass("slick-initialized")) {
        $slider.slick("setPosition");
      }
      
      var slide_count = $slider
        .find(".slick-track .slick-slide:not(.slick-cloned)")
        .length;

      console.log("slide_count:", slide_count);
      console.log("#prev_" + section_id)

      if (slide_count < 4) {
        $("#prev_" + section_id)
          .css({
            opacity: 0.2,
            pointerEvents: "none",
            cursor: "default"
          });

        $("#next_" + section_id)
          .css({
            opacity: 0.2,
            pointerEvents: "none",
            cursor: "default"
          });
      } else {
        $("#prev_" + section_id)
          .css({
            opacity: 1,
            pointerEvents: "auto",
            cursor: "pointer"
          });

        $("#next_" + section_id)
          .css({
            opacity: 1,
            pointerEvents: "auto",
            cursor: "pointer"
          });
      }


    });
  }

  $(".sm-img-slider").slick({
    dots: false,
    arrows: false,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // {
      //     breakpoint: 480,
      //     settings: {
      //         slidesToShow: 1,
      //         slidesToScroll: 1
      //     }
      // }
    ],
  });

  $(".collection-grid.sm-collection-grid").slick({
    dots: false,
    arrows: false,
    speed: 300,
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1178,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".sm-values--each__inner").on(
    "click",
    ".sm-values--content",
    function (event) {
      $(".sm-values--content").removeClass("active");
      $(this).addClass("active");
    }
  );

  if ($(".sm-values--each__inner").length) {
    $(".sm-values--each__inner .sm-values--content:first").addClass("active");
  }

  if ($(".sm-tab--block").length) {
    $(".sm-tab--block").each(function () {
      var $this = $(this);
      $(this)
        .find(".sm-tab--text__wrapper .sm-tab--text")
        .first()
        .show()
        .siblings()
        .hide();
      setTimeout(function () {
        $this
          .closest(".container")
          .find(".js-img-compare-wrapper .js-img-compare")
          .first()
          .show()
          .siblings()
          .hide();
      }, 300);

      $(this).find(".sm-tab--btn").first().addClass("active");
    });
  }
  $(".sm-tab--block .sm-tab--btn a").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var index = $this.parent().index();

    $this.parent().addClass("active").siblings().removeClass("active");

    $this
      .closest(".container")
      .find(".js-img-compare-wrapper .js-img-compare")
      .eq(index)
      .show()
      .siblings()
      .hide();

    $this
      .closest(".sm-tab--block")
      .find(".sm-tab--text__wrapper .sm-tab--text")
      .eq(index)
      .show()
      .siblings()
      .hide();
  });

  const classPattern = [
    "sm--image-50",
    "sm--image-50", // 1st and 2nd
    "sm--image-40", // 3rd
    "sm--image-30",
    "sm--image-30", // 4th and 5th
    "sm--image-50",
    "sm--image-50", // 6th and 7th
    "sm--image-30",
    "sm--image-30", // 8th and 9th
    "sm--image-40", // 10th
  ];

  $(".sm-image-block--content").each(function (index) {
    const patternIndex = index % classPattern.length; // Cycle through classPattern
    $(this).addClass(classPattern[patternIndex]);
  });

  // Vertical Slider

  var slider; //

  function initializeTNS() {
    if (
      $(
        ".sm-product-main-block .product .product__media-wrapper ul.product__media-list"
      ).length
    ) {
      slider = tns({
        container:
          ".sm-product-main-block .product .product__media-wrapper ul.product__media-list",
        items: 4,
        slideBy: 1,
        autoplay: true,
        axis: "vertical",
        draggable: true,
        mouseDrag: true,
        touch: true,
        controls: false,
        nav: false,
        speed: 300,
        loop: true,
      });
    }
  }

  function handleScroll(event) {
    var scrollDelta = event.originalEvent.deltaY;

    // Prevent scrolling the page when scrolling within the slider container
    event.preventDefault();
    event.stopPropagation();

    if (scrollDelta > 0) {
      // Scroll Down (Next slide)
      if (slider) {
        slider.goTo("next");
      }
    } else if (scrollDelta < 0) {
      // Scroll Up (Previous slide)
      if (slider) {
        slider.goTo("prev");
      }
    }
  }

  $(
    ".sm-product-main-block .product .product__media-wrapper ul.product__media-list"
  ).on("wheel", function (event) {
    handleScroll(event);
  });

  function initializeSlick() {
    const $carousel = $(
      ".sm-product-main-block .product .product__media-wrapper ul.product__media-list"
    );
    $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      adaptiveHeight: true,
    });
    const totalSlides = $carousel.slick("getSlick").slideCount;
    var slidePrev = $(
      ".sm-product-main-block .product-media-pagination .product-media-arrow.product-media-arrow-prev"
    );
    var slideNext = $(
      ".sm-product-main-block .product-media-pagination .product-media-arrow.product-media-arrow-next"
    );

    $(".product-media-total").text(totalSlides);

    $carousel.on("afterChange", function (event, slick, currentSlide) {
      const currentSlideItem = currentSlide + 1;
      $(".product-media-current").text(currentSlideItem);

      if (currentSlideItem > 1) {
        slidePrev.css("opacity", "1");
      } else {
        slidePrev.css("opacity", "0.5");
      }
    });

    slidePrev.on("click", function () {
      $carousel.slick("slickPrev");
    });
    slideNext.on("click", function () {
      $carousel.slick("slickNext");
    });
  }

  function productVerticalSlider() {
    $(
      ".sm-product-main-block .product .product__info-wrapper .product__info-container"
    ).each(function () {
      var $this = $(this);
      var contentHeight = $this.height();
      $this
        .closest(".product")
        .find(".product__media-wrapper")
        .css("height", contentHeight + "px");
    });
  }

  // Function to handle the resizing logic
  function handleResize() {
    if ($(window).width() > 768) {
      if (!slider) {
        productVerticalSlider();
        initializeTNS();
      }
    } else {
      if (slider) {
        slider.destroy();
        slider = null;
      }

      if (
        !$(
          ".sm-product-main-block .product .product__media-wrapper ul.product__media-list"
        ).hasClass("slick-initialized")
      ) {
        initializeSlick();
      }
    }
  }

  // Run on initial load
  handleResize();

  // Run on window resize
  $(window).on("resize", function () {
    handleResize();
  });

  $(
    ".sm-main--header .sm-search , .sm-main--header .search--block__close, .menu-search-trigger"
  ).on("click", function () {
    var mainHeader = $(".sm-main--header");

    if (mainHeader.hasClass("active--search")) {
      $(".sm-main--header").removeClass("active--search");
    } else {
      $(".sm-main--header").addClass("active--search");
    }
  });

  $(".footer--block-menu ul li a").on("click", function (e) {
    var $this = $(this);
    if ($this.find(".menu-search-trigger").length > 0) {
      e.preventDefault();
    } else {
      // Dont want preventdefault here
    }
  });

  $(".popup-modal, .pop-up--block__close").on("click", function () {
    var popUp = $(".popup-modal");

    if (popUp.hasClass("open")) {
      $(".popup-modal").removeClass("open");
    } else {
      $(".popup-modal").addClass("open");
    }
  });

  // Popup Subscription

  if (
    window.location.search.includes("customer_posted=true") &&
    window.location.hash === "#subscribe-popup"
  ) {
    setTimeout(function () {
      $(".popup-subscribe-trigger").click();
    }, 500);
  }

  if (!getCookie("popupDisplayed")) {
    setTimeout(function () {
      $(".popup-subscribe-trigger").click();
    }, 500);
  }

  $(".popup-subscribe-trigger").magnificPopup({
    type: "inline",
    preloader: false,
    modal: true,
    closeOnBgClick: true,
    fixedContentPos: true,
    callbacks: {
      beforeOpen: function () {},
      close: function () {
        setCookie("popupDisplayed", "true", 1);
      },
    },
  });

  $(".popup-make-an-offer-trigger").magnificPopup({
    type: "inline",
    preloader: false,
    modal: true,
    closeOnBgClick: true,
    fixedContentPos: true,
    callbacks: {
      beforeOpen: function () {
        var title = $(
          ".sm-product-main-block .product__info-wrapper.grid__item .product__title > h2"
        ).text();
        var price = $(
          ".sm-product-main-block .product__info-wrapper.grid__item .sm-product-item-price .price__sale .price-item"
        ).text();
        var image = $(
          ".sm-product-main-block .product__media-list .product__media-item"
        )
          .first()
          .find(".product-image img")
          .attr("src");

        $(".sm-pop-up.make-an-offer-popup .sm-pop-up-product__title h3").text(
          title
        );
        $(".sm-pop-up.make-an-offer-popup .sm-pop-up-product__price span").text(
          price
        );
        $(".sm-pop-up.make-an-offer-popup .sm-pop-up-product__image img").attr(
          "src",
          image
        );
      },
      close: function () {},
    },
  });

  $(document).on("click", ".sm-pop-up  .pop-up--block__close", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  $(".sequence-text[data-text]").each(function () {
    var spanElement = $(this); // Target each element with the "sequence" class
    var textArray = spanElement.attr("data-text").split(","); // Split the text into an array
    textSequence(0);

    function textSequence(i) {
      if (textArray.length > i) {
        animateText(textArray[i], function () {
          setTimeout(function () {
            textSequence(++i);
          }, 3000); // 1-second delay after the full text is displayed
        });
      } else if (textArray.length === i) {
        // Loop
        textSequence(0);
      }
    }

    function animateText(text, callback) {
      spanElement.html(""); // Clear the current content in the span
      let index = 0;

      function typeLetter() {
        if (index < text.length) {
          spanElement.append(
            `<span class="fade-in-letter">${text[index]}</span>`
          ); // Add a new letter with class for animation
          let newLetter = spanElement.find("span").last();
          setTimeout(() => newLetter.addClass("fade-in"), 10); // Add fade-in class to animate
          index++;
          setTimeout(typeLetter, 100); // Delay between letters
        } else if (callback) {
          callback(); // Execute callback when text animation is complete
        }
      }

      typeLetter();
    }
  });
  $(".sm-product-main-block .shopify-payment-button__button--unbranded").text(
    "Make An Offer"
  );

  // Print Product

  function getURLParameter(name) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  if (getURLParameter("view") === "print") {
    $(".sm-print-product-section").show().parent().show().siblings().hide();
    $("#shopify-section-header").hide();
    $("#shopify-section-footer").hide();

    setTimeout(function () {
      window.print();
    }, 500);
  } else {
    $("section.shopify-section")
      .show()
      .find(".sm-print-product-section")
      .parent()
      .hide();
    $("#shopify-section-header").show();
    $("#shopify-section-footer").show();
  }

  if ($(".footer--block-menu").length > 0) {
    $(".footer--block-menu li a").each(function () {
      var $this = $(this);
      var text = $this.text().trim();

      if (text == "Account") {
        $this.attr("target", "blank__");
      }
    });
  }

  // Added JS

  var headerHeight = $("header.sm-main--header").height();

  $(".sm-mega-menu .sm-mega-menu-block__menu > ul > li.has-dropdown")
    .first()
    .addClass("active");
  $(".sm-mega-menu-block__image-img").first().addClass("active");

  function disableMegaMenu() {
    $("header.sm-main--header").removeClass("mega-menu-active");
    $(".sm-mega-menu").hide();
    $(".sm-mega-menu .sm-mega-menu-block__menu > ul > li.has-dropdown")
      .first()
      .addClass("active");
    $(".sm-mega-menu-block__image-img").first().addClass("active");
  }

  $(".header--block.main--menu.desktop--block ul li a").on(
    "mouseenter",
    function () {
      $(".header--block.main--menu.desktop--block ul li").removeClass("active");
      $(".sm-mega-menu-block__image-img").removeClass("active");
      $(this).closest(".has-dropdown").addClass("active");
      $(
        ".sm-mega-menu .sm-mega-menu__inner .sm-mega-menu-block__menu ul li"
      ).removeClass("active");

      if ($(this).closest("li").hasClass("has-dropdown")) {
        $(".sm-mega-menu").show();
        $("header.sm-main--header").addClass("mega-menu-active");

        var $this = $(this);
        var $parentLi = $this.closest(".has-dropdown");
        var index = $parentLi.attr("count-data");

        $(
          ".sm-mega-menu .sm-mega-menu__inner .sm-mega-menu-block__menu ul li.dropdown-block-" +
            index
        ).addClass("active");
        $(".sm-mega-menu-block__image-img-" + index).addClass("active");
      } else {
        disableMegaMenu();
      }
    }
  );

  $("header.sm-main--header .header--bottom").mouseleave(function () {
    disableMegaMenu();
  });
});

$(document).ready(function () {
  // Handle fake "previous" clicks
  $('[id^="prevFake_"]').each(function () {
    const idSuffix = this.id.substring(9);
    $(this).on("click", function () {
      console.log("register_click #prev_" + idSuffix);
      $("#prev_" + idSuffix).trigger("click");
    });
  });

  // Handle fake "next" clicks
  $('[id^="nextFake_"]').each(function () {
    const idSuffix = this.id.substring(9);
    $(this).on("click", function () {
      console.log("register_click #next_" + idSuffix);
      $("#next_" + idSuffix).trigger("click");
    });
  });
});
